import {AfterViewInit, Component, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {
  AppTableComponent,
  ModalWindowComponent,
  SearchModel,
  SearchResultModel,
  SupplierAuctionRangListModel,
  SupplierAuctionRangListService,
  Auth,
  MessagesComponent,
  SearchUtil, SupplierOfferItemModel, SupplierAuctionOfferListModel, SupplierAuctionOfferService
} from 'src/common';
import {TranslationManager} from 'src/common/translation';
import {ActivatedRoute, Router} from '@angular/router';


@Component({
  selector: 'app-supplier-auction-rang-list-ssy1260list',
  templateUrl: './supplier-auction-rang-list-ssy1260list.component.html'
})
export class SupplierAuctionRangListSsy1260listComponent implements AfterViewInit, OnInit, OnDestroy {

  // custom-constructor-start
  constructor(private router: Router, private supplierAuctionRangListViewService: SupplierAuctionRangListService, private route: ActivatedRoute,
              private supplierAuctionOfferListService: SupplierAuctionOfferService) {
  }

  // custom-constructor-end

  @ViewChild(AppTableComponent) appTable: AppTableComponent;
  @ViewChild("modalWindow") modalWindow: ModalWindowComponent;
  translationManager = TranslationManager;
  items: SupplierAuctionRangListModel[];
  item: SupplierAuctionOfferListModel;
  idForDelete: number;
  showDeleteModal: boolean = false;
  auth = Auth;
  customHeaderText = '';
  requestRoundId: number;
  auctionId: number;
  messageInterval: any;
  lSuppid? : number;

  originalItems: SupplierAuctionRangListModel[];


  ngOnInit(): void {
    this.requestRoundId = +this.route.snapshot.params['id'];
    this.auctionId = +this.route.snapshot.params['auctionId'];


    if (this.auctionId) {
      let search = new SearchModel();
      search.filters = [];
      search.filters.push({'entity': "AuctionId", 'value': this.auctionId + '', 'action': "equals"});
      this.supplierAuctionOfferListService.search(search)
        .then((res: any) => {
          this.item = res.items[0];
        }).catch((reason: any) => {
        if (reason !== null) {
          if (reason.status === 400) {
            if (reason.error !== null) {
              if (reason.error.message) {
                const mescustom = reason.error.message;
                MessagesComponent.instance.showError([mescustom]);
              }
            }
          }
        }
      });
    }
    this.messageInterval = setInterval(() => {
      this.appTable.onSearch = this.doSearch.bind(this);
      this.appTable.search();
    }, 5000);
  }


  ngAfterViewInit(): void {
    this.appTable.onSearch = this.doSearch.bind(this);
    this.appTable.search();
  }

  ngOnDestroy(): void {
    clearInterval(this.messageInterval);
  }


  doSearch(search: SearchModel) {
    this.lSuppid = this.auth.user.supplierId
    let offset = (search.pagination.page - 1) * 10;
    let limit = search.pagination.page * 10;
      this.supplierAuctionRangListViewService.getAuctionRangList(this.requestRoundId).then((result: any) => {
        this.originalItems = result;

        let res = SearchUtil.searchList(this.originalItems.map(a => {
          return {...a}
        }), search);
        this.items = res.slice(offset, limit);

        let count = res.length;
        this.appTable.setTotalCount(count);

      }).catch((reason: any) => {
        if (reason !== null) {
          if (reason.status === 400) {
            if (reason.error !== null) {
              if (reason.error.message) {
                const mescustom = reason.error.message;
                MessagesComponent.instance.showError([mescustom]);
              } else if (reason.error.messages) {
                MessagesComponent.instance.showError(reason.error.messages);
              }
            }
          } else {
            MessagesComponent.instance.showError(reason.error.messages);
          }
        }
      });
  }

  create() {
    this.routerNavigateToCreate();
  }


  openDetails(id: number) {
    this.router.navigate(['/supplierAuctionRangLists/details/' + id]);
  }

  delete() {
    this.showDeleteModal = false;
    this.supplierAuctionRangListViewService.delete(this.idForDelete).then(() => {
      this.supplierAuctionRangListViewService.getAll().then((items: SupplierAuctionRangListModel[]) => {
        this.items = items;
      });
      MessagesComponent.instance.showSuccess([this.translationManager.getTranslation('Подаци су успешно обрисани')]);
    });
  }


  showDeleteModalFor(id: number) {
    this.idForDelete = id;
    this.showDeleteModal = true;
  }

  // custom-start
  private routerNavigateToCreate() {
    this.router.navigate(['supplier-auction-rang-list/create']);
  }

  back() {
    this.router.navigate(['auctions']);
  }

  // custom-end


}

